import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { useState, useCallback } from 'react';
import classNames from 'classnames';
import styles from './edc32f3f4b0f6fb3d40c4d3037d011f480e9026098fd16a97a473719db2f2d8a.cfe-internal.js';
import { useInputGroupContext } from '../InputGroup/fc923f7df98798752b55075d988c99381886b50e072df75d1b96be0b82f76494.cfe-internal.js';
import { useFormFieldContext } from '../FormField/f390dafefe74ba07f7da711a77443b7b51d96a6ad1aee47361fd1804064e9ba7.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import concatIds from '../../utils/concatIds/99a67648a55cf7a2ee84ef14be5ebb23af1b4b19b5520388cd5eef8f3f3a1e28.cfe-internal.js';

var _excluded = ["className", "value", "defaultValue", "disabled", "full", "invalid", "multiline", "onChange", "rows", "small", "type", "aria-describedby", "readOnly", "onCompositionStart", "onCompositionEnd"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var Input = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$full = _ref.full,
    full = _ref$full === void 0 ? false : _ref$full,
    _ref$invalid = _ref.invalid,
    invalid = _ref$invalid === void 0 ? false : _ref$invalid,
    multiline = _ref.multiline,
    onChange = _ref.onChange,
    _ref$rows = _ref.rows,
    rows = _ref$rows === void 0 ? 2 : _ref$rows,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    externalAriaDescribedBy = _ref['aria-describedby'],
    readOnly = _ref.readOnly,
    onCompositionStart = _ref.onCompositionStart,
    onCompositionEnd = _ref.onCompositionEnd,
    rest = _objectWithoutProperties(_ref, _excluded);
  var inputGroupContext = useInputGroupContext();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    compositionLock = _useState2[0],
    setCompositionLock = _useState2[1];
  var _useState3 = useState(defaultValue !== null && defaultValue !== void 0 ? defaultValue : ''),
    _useState4 = _slicedToArray(_useState3, 2),
    inputValue = _useState4[0],
    setInputValue = _useState4[1];
  var onChangeHandler = useCallback(function (event) {
    setInputValue(event.target.value);
    if (!compositionLock) {
      onChange === null || onChange === void 0 || onChange(event);
    }
  }, [compositionLock, onChange]);
  var onCompositionHandlerStart = useCallback(function (event) {
    setInputValue(event.currentTarget.value);
    setCompositionLock(true);
    if (onCompositionStart) {
      onCompositionStart(event);
    }
  }, [onCompositionStart]);
  var onCompositionHandlerEnd = useCallback(function (event) {
    setCompositionLock(false);
    if (onCompositionEnd) {
      onCompositionEnd(event);
    }
    if (onChange) {
      onChange(event);
    }
    if (value !== undefined) {
      setInputValue('');
    }
  }, [onCompositionEnd, onChange, value]);
  var _useFormFieldContext = useFormFieldContext(),
    formFieldHelperTextId = _useFormFieldContext.helperTextId,
    formFieldErrorTextId = _useFormFieldContext.errorTextId,
    formFieldIsReadOnly = _useFormFieldContext.isReadOnly;
  var internalAriaDescribedby = concatIds(externalAriaDescribedBy, formFieldHelperTextId, formFieldErrorTextId);
  var classes = classNames(styles.input, inputGroupContext.className, inputGroupContext.inputClassName, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles.full, inputGroupContext.applyFull(full)), styles.invalid, invalid), styles.small, inputGroupContext.applySmall(small)), styles.multiline, multiline), className);
  var commonProps = _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    className: classes,
    disabled: disabled,
    onCompositionStart: onCompositionHandlerStart,
    onCompositionEnd: onCompositionHandlerEnd,
    value: compositionLock ? inputValue : value !== null && value !== void 0 ? value : inputValue,
    'aria-invalid': invalid,
    'aria-describedby': internalAriaDescribedby,
    readOnly: readOnly !== null && readOnly !== void 0 ? readOnly : formFieldIsReadOnly,
    onChange: value && !onChange || disabled ? undefined : onChangeHandler
  });
  return multiline ? /*#__PURE__*/React__default.createElement("textarea", _extends({}, commonProps, {
    rows: rows
  })) : /*#__PURE__*/React__default.createElement("input", _extends({}, commonProps, {
    type: type
  }));
});

export { Input as default };
